import { SERVER } from '../../config/server.config';
import { FORCE_SCOPE, TEAMS_ALL } from '../../config/constants';
import { requestData } from '../../config/services/datasets';
import { MetaDataPlayerSearched, SearchesAction, SearchesPlayersData } from '../types';
import { AppThunk } from '../../config/commonTypes';
import { addLoadingFlag, subLoadingFlag } from './loading';
import { paramBuilder, routeToSpecificScope } from 'helpers';

export const replacePlayerSearchData = (data: SearchesPlayersData) => {
  return {
    type: SearchesAction.UPDATE_PLAYERS_SEARCH_DATA,
    playersData: data
  };
};

export const replaceCombinePlayerSearchData = (data: SearchesPlayersData, teamId: string) => {
  return {
    type: SearchesAction.UPDATE_COMBINE_PLAYERS_SEARCH_DATA,
    playersCombineData: data,
    teamId
  };
};

export const getPlayersSearchData = (): AppThunk => {
  return async (dispatch, getState) => {
    if (getState().searches.playersData.length === 0) {
      dispatch(addLoadingFlag(FORCE_SCOPE.PLAYERS_SEARCH_DATA_NAVBAR));
      const results = await requestData(SERVER.PLAYER_SEARCH(getState().user.league));
      let players = (results ? results.map((player: MetaDataPlayerSearched) => {
        const currentTeam = TEAMS_ALL.filter(team => team.teamId === player.teamId)[0] || {
          teamName: 'unavailable',
          teamAbbr: '-'
        };
        return {
          eid: player.eid,
          name: player.name,
          nid: player.nid,
          teamId: player.teamId,
          teamName: currentTeam.teamName,
          teamAbbr: currentTeam.teamAbbr,
          position: player.position,
          jersey: player.jersey,
        };
      }) : []);
      const playerSet = players.splice(0, players.length, ...(new Set(players) as unknown as any[]));
      players = [...playerSet];
      dispatch(replacePlayerSearchData(players));
      dispatch(subLoadingFlag(FORCE_SCOPE.PLAYERS_SEARCH_DATA_NAVBAR));
    }
  };
};

export const getCombinePlayersSearchData = (id:string, league:string): AppThunk => {
  return async (dispatch, getState) => {
      dispatch(addLoadingFlag(FORCE_SCOPE.PLAYERS_SEARCH_DATA_NAVBAR));
      const path = getState().router.location.pathname;
      const scope = routeToSpecificScope(path);
      const params = {
        league: { value: { value: league } },
        type: 'practice',
        teamids: id,
      };
      const results = await requestData(SERVER.ENTITIES_BY_TEAM(true) + paramBuilder(params));
      if (results) {
        dispatch(replaceCombinePlayerSearchData(results, id));
      }
      dispatch(subLoadingFlag(FORCE_SCOPE.PLAYERS_SEARCH_DATA_NAVBAR));
    
  };
};
